<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="{
                                path: '/Inventory/Stock/' + pages,
                                query: { q: form_query },
                            }"
                            >STOCK</router-link
                        >
                        / EDIT PART
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right"> </v-col>
            </v-row>
            <v-form method="post" id="nativeForm" v-model="valid">
                <v-card class="mt-5">
                    <v-card-title> </v-card-title>
                    <v-row class="mar-2">
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.projects"
                                item-text="project_name"
                                item-value="project_id"
                                v-model="form.project_id"
                                menu-props="auto"
                                label="Project Name"
                                :rules="ProjectR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.categories"
                                item-text="category_name"
                                item-value="category_id"
                                menu-props="auto"
                                label="Categories"
                                v-model="form.category_id"
                                :rules="CategoriesR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="dataGet.suppliers"
                                item-text="supplier_name"
                                item-value="supplier_id"
                                menu-props="auto"
                                label="Supplier"
                                v-model="form.supplier_id"
                                :rules="SupplierR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" class="pa-7">
                            <v-select
                                :items="['MA', 'Install']"
                                menu-props="auto"
                                label="Part Type"
                                v-model="form.part_type"
                                :rules="SupplierR"
                                required
                                hide-details
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" class="pa-7">
                            <v-textarea
                                outlined
                                name="part_no"
                                label="Part No"
                                :rules="part_noR"
                                required
                                v-model="form.part_name"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="pa-7">
                            <v-textarea
                                outlined
                                name="part_desc"
                                label="Part Description"
                                v-model="form.part_description"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-card-title>
                        <span class="headline headline-2"
                            >SET MINIMUM PART STOCK NONHP
                        </span>
                    </v-card-title>

                    <v-row
                        class="mar-2"
                        v-for="(n, index) in form.set_minimum"
                        :key="index"
                    >
                        <v-col cols="10" sm="5" md="4" class="pa-7">
                            <v-select
                                :items="data_branch"
                                item-text="branch_name"
                                item-value="branch_id"
                                v-model="n.branch"
                                menu-props="auto"
                                label="Select Branch"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="10" sm="5" md="4" class="pa-7">
                            <v-text-field
                                v-model="n.total"
                                label="Total"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="mt-5" v-if="index === num - 1">
                            <v-btn
                                color="success"
                                fab
                                small
                                class="mt-3"
                                @click="plus()"
                            >
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mar-2">
                        <v-col cols="12" class="text-right">
                            <v-btn
                                color="success"
                                class="mr-5"
                                @click="save()"
                                :disabled="!valid"
                                rounded
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/stockin`
const url_2 = `${process.env.VUE_APP_ROOT_API}/api/stock/`

export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    mounted() {
        this.get_data()
        this.get_branch()
        this.pages = this.$route.params.pages
        this.form_query = this.$route.query.q
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.get(url)
            let data_2 = await axios.get(url_2 + this.$route.params.id)
            this.form.part_type = data_2.data.part_type
            this.dataGet = data
            this.form = { ...data_2.data[0] }
            if (data_2.data[0].set_minimum.length != "") {
                this.num = data_2.data[0].set_minimum.length
            } else {
                this.num = 1
                this.form.set_minimum.branch = ""
                this.form.set_minimum.total = ""
            }
        },
        async get_branch() {
            let { data } = await axios.get(
                `${process.env.VUE_APP_ROOT_API}/api/getbranch`
            )
            this.data_branch = data
        },
        plus() {
            this.num = this.num + 1
            this.form.set_minimum.push({
                branch: "",
                total: "",
            })
        },
        async save() {
            let { data } = await axios.post(
                url_2 + this.$route.params.id,
                this.form
            )
            this.mutatesnackbar()
            this.$root.$router.push({
                path: "/Inventory/Stock/" + this.pages,
                // force: true
            })
        },
    },
    data() {
        return {
            dataGet: [],
            dataGet_2: [],
            form: {
                part_id: null,
                set_minimum: [
                    {
                        branch: "",
                        total: "",
                    },
                ],
            },
            pages: 0,
            valid: false,
            ProjectR: [(v) => !!v || "Project Name is required"],
            CategoriesR: [(v) => !!v || "Categories is required"],
            SupplierR: [(v) => !!v || "Supplier is required"],
            part_noR: [(v) => !!v || "Part No is required"],
            data_branch: [],
            num: 1,
            form_query: null,
        }
    },
}
</script>

<style scoped>
.mar-1 {
    margin-top: -30px !important;
}
.mar-2 {
    margin-top: -30px !important;
}
@media screen and (max-width: 960px) and (min-width: 600px) {
    .mar-1 {
        margin-top: 0px !important;
    }
}
</style>
